<template>
  <router-view/>
</template>

<style>
@import url('@/assets/css/styles.css');
</style>

<script>

export default {
  methods: {
    showAlert(type, msg) {
        var textMsg = '';

        if (msg.message) {
            if (typeof msg.errors === 'object' && msg.errors) {
                for (const key in msg.errors) {
                    if (Object.prototype.hasOwnProperty.call(msg.errors, key)) {
                    const errorMessages = msg.errors[key];
                    textMsg += `${errorMessages.join(', ')}<br>`;
                    }
                }
            } else {
                textMsg = `${msg.message}`;
            }
        } else {
            textMsg = `${msg}`;
        }

        this.$swal({
            text: textMsg,
            confirmButtonText: 'Confirm',
            html: textMsg,
            icon: type
        });
    },
  }
}

</script>